// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__V0s-b","head":"ProcedureTableInfo_head__3HkF8"};